const NavigationComponent = ({ pageIndex, setPageIndex }) => {

    const handleNavigation = (status) => {
        if (status === "prev") {
            setPageIndex(prev => Math.max(prev - 1, 1));
        } else if (status === "worldmap") {
        	setPageIndex(2);
        } else if (status === "next") {
            setPageIndex(prev => Math.min(prev + 1, 3));
        }
    };

    return (
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[calc(100%-30px)] md:w-full md:left-0 md:translate-x-0 flex gap-[10px] md:gap-[15px] justify-center p-4 md:p-5 bg-gray-100 overflow-x-auto rounded-[20px] md:rounded-t-none md:rounded-b-[20px]">
            <button
                className="px-4 md:px-7 py-2 md:py-3 text-sm md:text-base whitespace-nowrap shrink-0 rounded-full font-bold transition-all duration-300 shadow-md hover:-translate-y-[2px] hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed bg-white text-blue-800"
                onClick={() => handleNavigation("prev")}
                disabled={pageIndex === 1}
            >
                ← 이전
            </button>
            <button
                className="px-4 md:px-7 py-2 md:py-3 text-sm md:text-base whitespace-nowrap shrink-0 rounded-full font-bold transition-all duration-300 shadow-md hover:-translate-y-[2px] hover:shadow-lg bg-gradient-to-r from-blue-500 to-blue-600 text-white"
                onClick={() => handleNavigation("worldmap")}
            >
                🗺️ 세계지도
            </button>
            <button
            	className="px-4 md:px-7 py-2 md:py-3 text-sm md:text-base whitespace-nowrap shrink-0 rounded-full font-bold transition-all duration-300 shadow-md hover:-translate-y-[2px] hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed bg-white text-blue-800"
            	onClick={() => handleNavigation("next")}
            	disabled={pageIndex === 3}
            >
            	다음 →
            </button>
        </div>
    );
};

export default NavigationComponent;